import React from 'react';
import { Typography, Button, Theme, SxProps } from '@mui/material';

interface TmSaveButtonProps {
    onClick: () => void;
    children: string;
    width?: string;
    disabled?: boolean;
    sx?: SxProps<Theme>;
    startIcon?: React.ReactNode;
  }

  
const TmFullButton: React.FC<TmSaveButtonProps> = ({ onClick, children, width = "auto", disabled = false, sx, startIcon}) => {

    return (
        <Button
        style={{
            border: "1px",
            borderRadius: "25px",
            borderStyle: "solid",
            borderColor: "#9588e8",
            paddingLeft: "1em",
            paddingRight: "1em",
            paddingTop: "0.5em",
            paddingBottom: "0.5em",
        }}
        
        sx={{ 
            textAlign: "center",
            fontWeight: "bold",
            textTransform: "none",
            backgroundColor: "#9588e8",
            ":hover": {
                backgroundColor: "#9588e8",
            },
            ":disabled": {
                backgroundColor: "#e0e0e0 !Important",
                borderColor: "#e0e0e0 !Important",
            },
            color: "white",
            width: width,
            minWidth: "150px",
            height: "auto",
            minHeight: "40px",
            ...sx
        }}
        
        disabled={disabled}
        onClick={onClick}
        startIcon={startIcon}
        ><Typography fontWeight="bold">{children}</Typography></Button>
    );
}

export default TmFullButton;
